/* eslint-disable no-trailing-spaces */
/* eslint-disable padded-blocks */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-multiple-empty-lines */
/**
 * This file was auto-generated by ./scripts/generate-resource-api.js
 * Do not make direct changes to the file.
 */

 import { BaseResourceApi, type IResourceApiContext, type ApiOptions, type BaseRequestOptions } from '../common'
 import { createSchemaApiRequest, type ApiSchemaRequest, type ApiSchemaResponse } from '../schema'


class GeneratedCampaignTagApi extends BaseResourceApi {
  async add (config: ApiSchemaRequest<'/campaigns/{id}/tags', 'put'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/campaigns/{id}/tags', 'put'>> {

    return await createSchemaApiRequest({
      path: '/campaigns/{id}/tags',
      method: 'put',
      data: config.data,
      ctx: this.ctx,
      params: config.params,
      options: config
    })
  }

  async removes (config: ApiSchemaRequest<'/campaigns/{id}/tags/remove', 'put'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/campaigns/{id}/tags/remove', 'put'>> {

      return await createSchemaApiRequest({
        path: '/campaigns/{id}/tags/remove',
        method: 'put',
        data: config.data,
        ctx: this.ctx,
        params: config.params,
        options: config
      })
  }

  async removeAll (config: ApiSchemaRequest<'/campaigns/{id}/tags/all', 'delete'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/campaigns/{id}/tags/all', 'delete'>> {

    return await createSchemaApiRequest({
      path: '/campaigns/{id}/tags/all',
      method: 'delete',
      ctx: this.ctx,
      params: config.params,
      options: config
    })
  }
}

export class GeneratedCampaignApi extends BaseResourceApi {

  options: ApiOptions
  tags: GeneratedCampaignTagApi
  constructor (ctx: IResourceApiContext, options?: ApiOptions) {
    super(ctx)
    this.options = {
      currentUser: false,
      ...options
    }
    this.tags = new GeneratedCampaignTagApi(this.ctx)
  }
  
  async get (config: ApiSchemaRequest<'/campaigns/{id}', 'get'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/campaigns/{id}', 'get'>> {

    return await createSchemaApiRequest({
      path: '/campaigns/{id}',
      method: 'get',
      ctx: this.ctx,
      params: config.params,
      options: config
    })
  }

  async list (config: ApiSchemaRequest<'/campaigns', 'get'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/campaigns', 'get'>> {
    
    return await createSchemaApiRequest({
      path: this.options.currentUser ? '/currentuser/campaigns' : '/campaigns',
      method: 'get',
      ctx: this.ctx,
      query: config.query,
      options: config
    })
  }

  async count (config: ApiSchemaRequest<'/campaigns/count', 'get'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/campaigns/count', 'get'>> {
    
    return await createSchemaApiRequest({
      path: this.options.currentUser ? '/currentuser/campaigns/count' : '/campaigns/count',
      method: 'get',
      ctx: this.ctx,
      query: config.query,
      options: config
    })
  }

  async insert (config: ApiSchemaRequest<'/campaigns', 'post'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/campaigns', 'post'>> {
    
    return await createSchemaApiRequest({
      path: '/campaigns',
      method: 'post',
      ctx: this.ctx,
      data: config.data,
      options: config
    })
  }

  async update (config: ApiSchemaRequest<'/campaigns/{id}', 'put'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/campaigns/{id}', 'put'>> {
    
    return await createSchemaApiRequest({
      path: '/campaigns/{id}',
      method: 'put',
      params: config.params,
      ctx: this.ctx,
      data: config.data,
      query: config.query,
      options: config
    })
  }
  
}
